import * as React from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";
import { Markdown } from "src/components/ui/Markdown";

import { CardBox } from "../components";

interface ToolCallResultProps {
  content: string | null;
  artifactId?: string | null;
}

export const ToolCallResult: React.FC<ToolCallResultProps> = ({
  content,
}) => {
  return (
    <CardBox title="Result">
      {content ? (
        <div>
          <Markdown>{content}</Markdown>
        </div>
      ) : (
        <div className="flex items-center justify-center py-6 text-gray-500 italic text-sm">
          <LoadingSpinner className="h-4 w-4 mr-2" />
          Waiting for result...
        </div>
      )}
    </CardBox>
  );
};